import { ReactNode } from "react";

type Props = {
  children: ReactNode;
  header?: ReactNode;
  footer?: ReactNode;
};
export default function PlayerMenuContent({ children, header, footer }: Props) {
  return (
    <div className="flex flex-col gap-7.5 w-full h-full px-10 py-7.5">
      {header}
      <div className="relative grow">
        <div className="absolute inset-0 overflow-y-auto overflow-hidden -mx-10 px-10">
          {children}
        </div>
      </div>
      {footer}
    </div>
  );
}
